import { pushToDatalayer } from '@luks/meta/src';
import React, { useEffect } from 'react';

export const Gtm: React.FC<{ gtmData?: string }> = ({ gtmData }) => {
  useEffect(() => {
    pushToDatalayer(gtmData, 'page-load');
  }, [gtmData]);
  return null;
};
